import { observer } from 'mobx-react';
import React from 'react';

import { OrderItemListItem } from '@components/order-item-list-item';
import { useFreeGiftOrderItem } from '../../hooks/use-free-gift-order-item';

/**
 * The chosen Surprise & Delight gift rendered as a standalone removable
 * "Free gift" row.
 *
 * Only used where the gift can't be composed into a single order items list —
 * the group-host cart, which renders one list per sub-cart. Every other
 * surface composes the synthetic item from `useFreeGiftOrderItem` into its
 * `OrderItemList` via `withFreeGiftOrderItem` (state-management), which owns
 * the gift's position in the list.
 *
 * Renders null when no gift is selected.
 */
const FreeGiftOrderItem = () => {
  const orderItem = useFreeGiftOrderItem({ removable: true });

  if (!orderItem) {
    return null;
  }

  return (
    <OrderItemListItem
      orderItem={orderItem}
      setProductDetailModalOpen={() => {}}
      showDaypart={false}
      tags={orderItem.tags}
      removeOnly
      onRemove={orderItem.onRemove}
    />
  );
};

const ComposedFreeGiftOrderItem = observer(FreeGiftOrderItem);

export { ComposedFreeGiftOrderItem as FreeGiftOrderItem };
